<template>
  <div>
    <div class="topTitle">
      <el-page-header @back="goback" content="参赛人员"> </el-page-header>
    </div>
    <div class="stu">
      <el-form ref="form" :model="form1" :inline="true" size="mini">
        <el-form-item style="float:right" label="审核状态">
          <el-select style="width:140px" v-model="form1.check_state" placeholder="请选择审核状态" clearable @change="search3">
            <el-option label="通过" value="1"></el-option>
            <el-option label="未通过" value="0"></el-option>
            <el-option label="未审核" value="null"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" @click="addstu" size="mini">添加人员</el-button>
        <el-button type="primary" @click="isCheck2" size="mini">批量通过</el-button>
        <el-button type="primary" @click="isCheck3" size="mini">批量拒绝</el-button>
        <el-button type="primary" @click="dels" size="mini">批量删除</el-button>
        <el-button type="primary" plain @click="()=>ojTestcaseAuthShow=true" size="mini">测试点权限</el-button>
      </el-form>

      <div>
        <el-table :data="tableData" stripe style="width: 100%;margin-top: 20px;" :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }" @selection-change="handleSelectionChange1">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="realname" label="姓名">
            <template slot-scope="scope">
              <span v-if="scope.row.user_id === null">{{ scope.row.realname }}
                <span style="color:#FCBB30">(学生)</span></span>
              <span v-else>{{ scope.row.realname }}
                <span style="color:#FCBB30">(教师)</span></span>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="平台账号"></el-table-column>

          <el-table-column prop="schoolName" label="所属校区">
          </el-table-column>
          <el-table-column prop="check_state" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.check_state === 1">已通过</span>
              <span v-if="scope.row.check_state === 0">未通过</span>
              <span v-if="scope.row.check_state === null">未审核</span>
            </template>
          </el-table-column>
          <el-table-column prop="ojTestcaseAuth" label="测试点">
            <template slot-scope="scope">
              <el-switch v-if="!scope.row.user_id" v-model="scope.row.ojTestcaseAuth" active-color="#13ce66" inactive-color="#ff4949" @change="handleChangeStuOjTestcaseAuth($event,scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="scope.row.check_state === 1" @click="isCheck(scope.row)">已通过</el-button>
              <el-button type="text" size="mini" v-if="scope.row.check_state === 0" @click="isCheck1(scope.row)">未通过</el-button>
              <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 20px; text-align: right">
          <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="选择参赛人员" :visible.sync="dialogVisible" width="80%" top="5vh">
        <el-tabs v-model="activeName">
          <el-tab-pane label="学生列表" name="first">
            <el-form ref="form" :model="form" :inline="true" size="mini">
              <el-form-item label="学生账号">
                <el-input v-model="form.username" clearable placeholder="请输入学生账号"></el-input>
              </el-form-item>
              <el-form-item label="学员姓名">
                <el-input v-model="form.realname" clearable placeholder="请输入学生账号"></el-input>
              </el-form-item>
              <el-form-item label="班级名称">
                <el-input v-model="form.className" clearable placeholder="请输入学生账号"></el-input>
              </el-form-item>

              <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>
            </el-form>
            <div style="overflow: hidden;">
              <div class="fl" style="width: 62%;">
                <el-table ref="tableRefStu" :row-key="
                    (row) => {
                      return row.id;
                    }
                  " :data="tableData1" size="mini" style="width: 100%;border:1px solid #F2F6FC;border-radius: 5px;" height="45vh" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#606266',
                    'font-size': '14px',
                  }" @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="55" :reserve-selection="true">
                  </el-table-column>
                  <el-table-column prop="realName" label="姓名">
                  </el-table-column>
                  <el-table-column prop="name" label="账号"> </el-table-column>

                  <el-table-column prop="schoolName" label="校区">
                  </el-table-column>
                  <el-table-column align="left" label="所在班级" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span>{{ scope.row.class_str }}</span>
                    </template>
                  </el-table-column>
                </el-table>

                <div style="margin: 20px; text-align: right">
                  <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
                  </el-pagination>
                </div>
              </div>
              <div class="fr" style="width: 36%;">
                <div>
                  <el-table :data="multipleSelectionStu" size="mini" style="width: 100%;border:1px solid #F2F6FC;border-radius: 5px;" height="45vh" :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#606266',
                      'font-size': '14px',
                    }">
                    <el-table-column prop="realName" label="已选">
                    </el-table-column>
                    <el-table-column prop="name" label="账号">
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="handleClose(scope.row)">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- <el-tag v-for="tag in multipleSelectionStu" :key="tag.id" closable
                    style="margin-right: 5px;margin-bottom: 5px;" @close="handleClose(tag)">
                    {{ tag.realName }}
                  </el-tag> -->
                </div>
              </div>
            </div>

            <div class="fr">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit">确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="教师列表" name="second">
            <el-form ref="form" :model="form2" :inline="true" size="mini">
              <el-form-item label="老师账号">
                <el-input v-model="form2.username" placeholder="请输入老师账号" clearable></el-input>
              </el-form-item>

              <el-button type="primary" @click="search1" icon="el-icon-search" size="mini">查询</el-button>
            </el-form>
            <div style="overflow: hidden;">
              <div style="width: 62%;" class="fl">
                <el-table ref="tableRefTch" :row-key="
                    (row) => {
                      return row.id;
                    }
                  " :data="tableData2" size="mini" style="width: 100%;border:1px solid #F2F6FC;border-radius: 5px;" height="45vh" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#606266',
                    'font-size': '14px',
                  }" @selection-change="handleSelectionChange3">
                  <el-table-column type="selection" width="55" :reserve-selection="true">
                  </el-table-column>

                  <el-table-column prop="realName" label="姓名">
                  </el-table-column>
                  <el-table-column prop="name" label="账号"> </el-table-column>

                  <el-table-column prop="schoolName" label="校区">
                  </el-table-column>
                </el-table>
                <div style="margin: 20px; text-align: right">
                  <el-pagination @current-change="handleCurrent2" :current-page="page_no2" :page-size="page_size2" layout="total, prev, pager, next, jumper" :total="total2">
                  </el-pagination>
                </div>
              </div>
              <div class="fr" style="width: 36%;">
                <div>
                  <div>
                    <el-table :data="multipleSelectionTch" size="mini" stripe style="width: 100%;border:1px solid #F2F6FC;border-radius: 5px;" height="45vh" :header-cell-style="{
                        background: '#f5f7fa',
                        color: '#606266',
                        'font-size': '14px',
                      }">
                      <el-table-column prop="realName" label="已选">
                      </el-table-column>

                      <el-table-column prop="name" label="账号">
                      </el-table-column>

                      <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                          <el-button type="text" size="mini" @click="handleClose1(scope.row)">移除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- <el-tag v-for="tag in multipleSelectionTch" :key="tag.id" closable
                    style="margin-right: 5px;margin-bottom: 5px;" @close="handleClose1(tag)">
                    {{ tag.realName }}
                  </el-tag> -->
                </div>
              </div>
            </div>

            <div class="fr">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit1">确 定</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span> -->
      </el-dialog>
    </div>
    <el-dialog title="测试点权限" :visible.sync="ojTestcaseAuthShow" width="250px">
      <div class="clearfix">
        <div class="fl">
          <el-button type="primary" @click="ojTchUpdateContestAllStuOjTestcaseAuth(true)">开启权限</el-button>
        </div>
        <div class="fr">
          <el-button @click="ojTchUpdateContestAllStuOjTestcaseAuth(false)">关闭权限</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  tchGetStuListForAddContestUser,
  tchGetUserListForAddContestUser,
  tchAddContestSign,
  tchGetOjContestSignList,
  tchUpdateContestSignCheckState,
  tchDeleteContestSign,
  // tchGetOjContestSignList,
  // tchGetStuListForAddContestUser,
  // tchAddContestSign,
  // tchUpdateContestSignCheckState,
  // tchGetUserListForAddContestUser,
  ojTchUpdateContestAllStuOjTestcaseAuth, // 更新oj比赛全部学生查看测试用例的权限
  ojTchUpdateTeamSingleStuOjTestcaseAuth, // 更新oj比赛单个学生查看测试用例的权限

} from "@/api/educational.js";
export default {
  data() {
    return {
      page_no2: 1,
      page_size2: 10,
      total2: 0,
      form2: {},
      tableData2: [],
      form1: {},
      form: {},
      dialogVisible: false,
      activeName: "first",
      tableData1: [],
      contest_id: "",
      tableData: [],
      page_no: 1,
      page_size: 20,
      total: 20,
      page_no1: 1,
      page_size1: 10,
      total1: 0,
      multipleSelectionTch: [],
      multipleSelection: [],
      multipleSelectionStu: [],
      multipleSelection1: [],
      multipleSelection2: [],
      ojTestcaseAuthShow: false
    };
  },
  created() {
    this.contest_id = this.$route.query.id;
  },
  mounted() {
    this.tchGetOjContestSignList();
  },
  methods: {
    search3() {
      this.page_no = 1;
      this.tchGetOjContestSignList();
    },
    search1() {
      this.page_no2 = 1;
      this.tchGetUserListForAddContestUser();
    },
    search() {
      this.page_no1 = 1;
      this.tchGetStuListForAddContestUser();
    },
    goback() {
      this.$router.go(-1);
    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning("请选中再进行删除!");
        return false;
      }
      tchDeleteContestSign({
        contestSignIds: JSON.stringify(this.multipleSelection1),
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.tchGetOjContestSignList();
      });
    },
    del(row) {
      console.log(row.id);
      let ids = [];
      ids.push(row.id);
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tchDeleteContestSign({
            contestSignIds: JSON.stringify(ids),
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.tchGetOjContestSignList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    isCheck2() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning("请选中!");
        return false;
      }
      tchUpdateContestSignCheckState({
        contestSignIds: JSON.stringify(this.multipleSelection1),
        check_state: 1,
      }).then((res) => {
        console.log(res);
        this.$message.success("修改成功");
        this.tchGetOjContestSignList();
      });
    },
    isCheck3() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning("请选中!");
        return false;
      }
      tchUpdateContestSignCheckState({
        contestSignIds: JSON.stringify(this.multipleSelection1),
        check_state: 0,
      }).then((res) => {
        console.log(res);
        this.$message.success("修改成功");
        this.tchGetOjContestSignList();
      });
    },
    isCheck(row) {
      tchUpdateContestSignCheckState({
        contestSignIds: JSON.stringify([row.id]),
        check_state: 0,
      }).then((res) => {
        console.log(res);
        this.$message.success("修改成功");
        this.tchGetOjContestSignList();
      });
    },
    isCheck1(row) {
      tchUpdateContestSignCheckState({
        contestSignIds: JSON.stringify([row.id]),
        check_state: 1,
      }).then((res) => {
        console.log(res);
        this.$message.success("修改成功");
        this.tchGetOjContestSignList();
      });
    },
    submit1() {
      tchAddContestSign({
        contest_id: this.contest_id,
        userInfoArr: JSON.stringify(this.multipleSelection2),
        userRole: 2,
      }).then((res) => {
        console.log(res);
        this.$message.success("添加成功！");
        this.dialogVisible = false;
        this.tchGetOjContestSignList();
      });
    },
    submit() {
      tchAddContestSign({
        contest_id: this.contest_id,
        userInfoArr: JSON.stringify(this.multipleSelection),
        userRole: 1,
      }).then((res) => {
        console.log(res);
        this.$message.success("添加成功！");
        this.dialogVisible = false;
        this.tchGetOjContestSignList();
      });
    },
    handleSelectionChange3(val) {
      this.multipleSelectionTch = [];
      this.multipleSelectionTch = val;
      let arr = [];
      this.multipleSelection2 = [];
      for (let k = 0; k < val.length; k++) {
        let obg = {
          code: val[k].code,
          id: val[k].id,
          schoolId: val[k].schoolId,
        };
        arr.push(obg);
        console.log(arr, 111);
        this.multipleSelection2 = arr;
      }
      console.log(this.multipleSelection2);
    },
    handleClose1(val) {
      console.log(val, 1245415);
      this.multipleSelection2.map((item) => {
        if (item == val.id) {
          this.multipleSelection2.splice(
            this.multipleSelection2.indexOf(item),
            1
          );
        }
      });
      this.$nextTick(() => {
        this.$refs.tableRefTch.toggleRowSelection(val, false);
      });
    },
    addstu() {
      this.$nextTick(() => {
        this.$refs.tableRefStu.clearSelection();
        this.$refs.tableRefTch.clearSelection();
      });
      this.multipleSelectionTch = [];
      this.multipleSelectionStu = [];
      this.dialogVisible = true;
      this.tchGetStuListForAddContestUser();
      this.tchGetUserListForAddContestUser();
    },
    handleClose(val) {
      console.log(val, 1245415);
      this.multipleSelection.map((item) => {
        if (item == val.id) {
          this.multipleSelection.splice(
            this.multipleSelection.indexOf(item),
            1
          );
        }
      });
      this.$nextTick(() => {
        this.$refs.tableRefStu.toggleRowSelection(val, false);
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelectionStu = [];
      this.multipleSelectionStu = val;
      let arr = [];
      this.multipleSelection = [];
      for (let k = 0; k < val.length; k++) {
        let obg = {
          code: val[k].code,
          id: val[k].id,
          schoolId: val[k].schoolId,
        };
        arr.push(obg);
        console.log(arr, 111);
        this.multipleSelection = arr;
      }
      console.log(this.multipleSelection, 669);
      console.log(this.multipleSelectionStu, 669);
    },
    handleSelectionChange1(val) {
      console.log(val);
      let arr = [];
      this.multipleSelection1 = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id);
        console.log(arr);
        this.multipleSelection1 = arr;
      }
      console.log(this.multipleSelection1);
    },
    //获取比赛学生列表
    tchGetOjContestSignList() {
      tchGetOjContestSignList({
        ...this.form1,
        contest_id: this.contest_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res);
        this.tableData = res.OjContestSignList;
        this.total = res.total;
      });
    },
    handleCurrent(val) {
      this.page_no = val;
      this.tchGetOjContestSignList();
    },
    handleCurrent1(val) {
      this.page_no1 = val;
      this.tchGetStuListForAddContestUser();
    },

    tchGetStuListForAddContestUser() {
      tchGetStuListForAddContestUser({
        ...this.form,
        contest_id: this.contest_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res);
        this.tableData1 = res.studentList;
        this.total1 = res.total;
        //班级列表转字符串

        for (let k = 0; k < this.tableData1.length; k++) {
          this.tableData1[k].classlist = [];
          for (let j = 0; j < this.tableData1[k].stuClassArr.length; j++) {
            // console.log(this.tableData2[k].stuClassArr[j].classInfo.name);
            this.tableData1[k].classlist.push(
              this.tableData1[k].stuClassArr[j].className
            );
          }

          //  console.log(this.tableData2[k].classlist);
          this.tableData1[k].class_str = this.tableData1[k].classlist.join(
            " , "
          );
        }
      });
    },

    tchGetUserListForAddContestUser() {
      tchGetUserListForAddContestUser({
        ...this.form2,
        contest_id: this.contest_id,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log(res);
        this.tableData2 = res.userList;
        this.total2 = res.total;
      });
    },
    handleCurrent2(val) {
      this.page_no2 = val;
      this.tchGetUserListForAddContestUser();
    },
    handleChangeStuOjTestcaseAuth(e, item) {
      console.log(e, item)
      this.ojTchUpdateTeamSingleStuOjTestcaseAuth(item.stu_user_id, e)
    },
    // 更新oj比赛全部学生查看测试用例的权限
    ojTchUpdateContestAllStuOjTestcaseAuth(oj_testcase_auth) {
      ojTchUpdateContestAllStuOjTestcaseAuth({
        oj_contest_id: this.contest_id,
        oj_testcase_auth,
      }).then(res => {
        console.log(res)
        this.$message.success("修改成功");
        this.ojTestcaseAuthShow = false;
        this.tchGetOjContestSignList();
      })
    },
    // 更新oj比赛单个学生查看测试用例的权限
    ojTchUpdateTeamSingleStuOjTestcaseAuth(stuId, oj_testcase_auth) {
      ojTchUpdateTeamSingleStuOjTestcaseAuth({ stuId, oj_testcase_auth }).then(res => {
        console.log(res)
        this.$message.success("修改成功");
        this.tchGetOjContestSignList();
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.stu {
  margin: 10px;
  padding: 20px;
  min-height: 100vh;

  background: white;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>
